module.exports = __webpack_public_path__ + "img/tr-note-icon.d775fb1d.svg";